import Icon from '@components/dataDisplay/Icons/Icon';
import React from 'react';
import styled, { css } from 'styled-components';

export const OvalButton = styled.button<{ disabled?: boolean }>`
  width: 54px;
  height: 32px;
  border: 1px solid var(--lineColor);
  border-radius: 100px;
  background: transparent;
  transition: 0.2s;
  font-family: var(--defaultFontFamily);
  font-size: 13px;
  color: var(--textColor);

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    border: 1px solid var(--primaryColor);
    color: var(--primaryColor);
  }
`;

export const RoundButton = styled.button<{ disabled?: boolean }>`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  background: transparent;
  position: relative;
  transition: 0.2s;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    border: 1px solid var(--primaryColor);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    border: 1px solid var(--lineColor);
  }
`;

type CalendarButtonProps = {
  type: 'text' | 'left' | 'right';
  text?: string;
  onClick: () => void;
  disabled?: boolean;
};

const CalendarButton = ({
  type,
  text,
  onClick,
  disabled,
}: CalendarButtonProps) => {
  switch (type) {
    case 'text':
      return (
        <OvalButton onClick={onClick} disabled={disabled}>
          <span>{text}</span>
        </OvalButton>
      );
    case 'left':
      return (
        <RoundButton onClick={onClick} disabled={disabled}>
          <Icon name="LeftArrowO" color="var(--textColor)" />
        </RoundButton>
      );
    case 'right':
      return (
        <RoundButton onClick={onClick} disabled={disabled}>
          <Icon name="RightArrowO" color="var(--textColor)" />
        </RoundButton>
      );
  }
};

export default CalendarButton;
